import { Box } from "@mui/material";
import React, { useCallback } from "react";
import styles from "../EstateFilterDialog.module.scss";

export const OtherConditionButton = React.memo(
  (props: {
    petOk: boolean;
    flat: boolean;
    forRent: boolean;
    exceptForRent: boolean;
    myCompanyOnly: boolean;
    venderOnly: boolean;

    isAdministrator: boolean;
    isPricingAvailable: boolean;

    onPetOkChange: (checked: boolean) => void;
    onFlatChange: (checked: boolean) => void;
    onForRentChange: (checked: boolean) => void;
    onExceptForRentChange: (checked: boolean) => void;
    onMyCompanyOnlyChange: (checked: boolean) => void;
    onVenderOnlyChange: (checked: boolean) => void;
  }) => {
    const onPetOkClick = useCallback(
      () => props.onPetOkChange(!props.petOk),
      [props]
    );

    const onFlatClick = useCallback(
      () => props.onFlatChange(!props.flat),
      [props]
    );

    const onForRentClick = useCallback(
      () => props.onForRentChange(!props.forRent),
      [props]
    );

    const onExceptForRentClick = useCallback(
      () => props.onExceptForRentChange(!props.exceptForRent),
      [props]
    );

    const onMyCompanyOnlyClick = useCallback(
      () => props.onMyCompanyOnlyChange(!props.myCompanyOnly),
      [props]
    );

    const onVenderOnlyClick = useCallback(
      () => props.onVenderOnlyChange(!props.venderOnly),
      [props]
    );

    return (
      <>
        <Box
          onClick={onPetOkClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.pet
          } ${props.petOk ? styles.on : styles.off}`}
        >
          ペット可のみ
        </Box>
        <Box
          onClick={onFlatClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.hiraya
          } ${props.flat ? styles.on : styles.off}`}
        >
          平屋のみ
        </Box>
        <Box
          onClick={onForRentClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.chintai
          } ${props.forRent ? styles.on : styles.off}`}
        >
          賃貸中のみ
        </Box>
        <Box
          onClick={onExceptForRentClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.chintai
          } ${props.exceptForRent ? styles.on : styles.off}`}
        >
          賃貸中除く
        </Box>
        <Box
          onClick={onMyCompanyOnlyClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.own
          } ${props.myCompanyOnly ? styles.on : styles.off}`}
        >
          自社物件のみ
        </Box>
        <Box
          onClick={onVenderOnlyClick}
          className={`${styles.btn_switch01} ${styles.click_act01} ${
            styles.own
          } ${props.venderOnly ? styles.on : styles.off}`}
        >
          売主のみ
        </Box>
      </>
    );
  }
);
